exports.country = [
  {
    "name": "Afghanistan",
    "alpha2": "AF",
    "alpha3": "AFG",
    "country-code": "004",
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Åland Islands",
    "alpha2": "AX",
    "alpha3": "ALA",
    "country-code": 248,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Albania",
    "alpha2": "AL",
    "alpha3": "ALB",
    "country-code": "008",
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Algeria",
    "alpha2": "DZ",
    "alpha3": "DZA",
    "country-code": "012",
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "American Samoa",
    "alpha2": "AS",
    "alpha3": "ASM",
    "country-code": "016",
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Andorra",
    "alpha2": "AD",
    "alpha3": "AND",
    "country-code": "020",
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Angola",
    "alpha2": "AO",
    "alpha3": "AGO",
    "country-code": "024",
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Anguilla",
    "alpha2": "AI",
    "alpha3": "AIA",
    "country-code": 660,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Antarctica",
    "alpha2": "AQ",
    "alpha3": "ATA",
    "country-code": "010",
    "region": "",
    "sub-region": "",
    "intermediate-region": "",
    "region-code": "",
    "sub-region-code": "",
    "intermediate-region-code": ""
  },
  {
    "name": "Antigua and Barbuda",
    "alpha2": "AG",
    "alpha3": "ATG",
    "country-code": "028",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Argentina",
    "alpha2": "AR",
    "alpha3": "ARG",
    "country-code": "032",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Armenia",
    "alpha2": "AM",
    "alpha3": "ARM",
    "country-code": "051",
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Aruba",
    "alpha2": "AW",
    "alpha3": "ABW",
    "country-code": 533,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Australia",
    "alpha2": "AU",
    "alpha3": "AUS",
    "country-code": "036",
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "Austria",
    "alpha2": "AT",
    "alpha3": "AUT",
    "country-code": "040",
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Azerbaijan",
    "alpha2": "AZ",
    "alpha3": "AZE",
    "country-code": "031",
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Bahamas",
    "alpha2": "BS",
    "alpha3": "BHS",
    "country-code": "044",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Bahrain",
    "alpha2": "BH",
    "alpha3": "BHR",
    "country-code": "048",
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Bangladesh",
    "alpha2": "BD",
    "alpha3": "BGD",
    "country-code": "050",
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Barbados",
    "alpha2": "BB",
    "alpha3": "BRB",
    "country-code": "052",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Belarus",
    "alpha2": "BY",
    "alpha3": "BLR",
    "country-code": 112,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Belgium",
    "alpha2": "BE",
    "alpha3": "BEL",
    "country-code": "056",
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Belize",
    "alpha2": "BZ",
    "alpha3": "BLZ",
    "country-code": "084",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Benin",
    "alpha2": "BJ",
    "alpha3": "BEN",
    "country-code": 204,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Bermuda",
    "alpha2": "BM",
    "alpha3": "BMU",
    "country-code": "060",
    "region": "Americas",
    "sub-region": "Northern America",
    "intermediate-region": "",
    "region-code": "019",
    "sub-region-code": "021",
    "intermediate-region-code": ""
  },
  {
    "name": "Bhutan",
    "alpha2": "BT",
    "alpha3": "BTN",
    "country-code": "064",
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Bolivia (Plurinational State of)",
    "alpha2": "BO",
    "alpha3": "BOL",
    "country-code": "068",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Bonaire, Sint Eustatius and Saba",
    "alpha2": "BQ",
    "alpha3": "BES",
    "country-code": 535,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Bosnia and Herzegovina",
    "alpha2": "BA",
    "alpha3": "BIH",
    "country-code": "070",
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Botswana",
    "alpha2": "BW",
    "alpha3": "BWA",
    "country-code": "072",
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Southern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "018"
  },
  {
    "name": "Bouvet Island",
    "alpha2": "BV",
    "alpha3": "BVT",
    "country-code": "074",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Brazil",
    "alpha2": "BR",
    "alpha3": "BRA",
    "country-code": "076",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "British Indian Ocean Territory",
    "alpha2": "IO",
    "alpha3": "IOT",
    "country-code": "086",
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Brunei Darussalam",
    "alpha2": "BN",
    "alpha3": "BRN",
    "country-code": "096",
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Bulgaria",
    "alpha2": "BG",
    "alpha3": "BGR",
    "country-code": 100,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Burkina Faso",
    "alpha2": "BF",
    "alpha3": "BFA",
    "country-code": 854,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Burundi",
    "alpha2": "BI",
    "alpha3": "BDI",
    "country-code": 108,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Cabo Verde",
    "alpha2": "CV",
    "alpha3": "CPV",
    "country-code": 132,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Cambodia",
    "alpha2": "KH",
    "alpha3": "KHM",
    "country-code": 116,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Cameroon",
    "alpha2": "CM",
    "alpha3": "CMR",
    "country-code": 120,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Canada",
    "alpha2": "CA",
    "alpha3": "CAN",
    "country-code": 124,
    "region": "Americas",
    "sub-region": "Northern America",
    "intermediate-region": "",
    "region-code": "019",
    "sub-region-code": "021",
    "intermediate-region-code": ""
  },
  {
    "name": "Cayman Islands",
    "alpha2": "KY",
    "alpha3": "CYM",
    "country-code": 136,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Central African Republic",
    "alpha2": "CF",
    "alpha3": "CAF",
    "country-code": 140,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Chad",
    "alpha2": "TD",
    "alpha3": "TCD",
    "country-code": 148,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Chile",
    "alpha2": "CL",
    "alpha3": "CHL",
    "country-code": 152,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "China",
    "alpha2": "CN",
    "alpha3": "CHN",
    "country-code": 156,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Christmas Island",
    "alpha2": "CX",
    "alpha3": "CXR",
    "country-code": 162,
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "Cocos (Keeling) Islands",
    "alpha2": "CC",
    "alpha3": "CCK",
    "country-code": 166,
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "Colombia",
    "alpha2": "CO",
    "alpha3": "COL",
    "country-code": 170,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Comoros",
    "alpha2": "KM",
    "alpha3": "COM",
    "country-code": 174,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Congo",
    "alpha2": "CG",
    "alpha3": "COG",
    "country-code": 178,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Congo, Democratic Republic of the",
    "alpha2": "CD",
    "alpha3": "COD",
    "country-code": 180,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Cook Islands",
    "alpha2": "CK",
    "alpha3": "COK",
    "country-code": 184,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Costa Rica",
    "alpha2": "CR",
    "alpha3": "CRI",
    "country-code": 188,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Côte d'Ivoire",
    "alpha2": "CI",
    "alpha3": "CIV",
    "country-code": 384,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Croatia",
    "alpha2": "HR",
    "alpha3": "HRV",
    "country-code": 191,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Cuba",
    "alpha2": "CU",
    "alpha3": "CUB",
    "country-code": 192,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Curaçao",
    "alpha2": "CW",
    "alpha3": "CUW",
    "country-code": 531,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Cyprus",
    "alpha2": "CY",
    "alpha3": "CYP",
    "country-code": 196,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Czechia",
    "alpha2": "CZ",
    "alpha3": "CZE",
    "country-code": 203,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Denmark",
    "alpha2": "DK",
    "alpha3": "DNK",
    "country-code": 208,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Djibouti",
    "alpha2": "DJ",
    "alpha3": "DJI",
    "country-code": 262,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Dominica",
    "alpha2": "DM",
    "alpha3": "DMA",
    "country-code": 212,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Dominican Republic",
    "alpha2": "DO",
    "alpha3": "DOM",
    "country-code": 214,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Ecuador",
    "alpha2": "EC",
    "alpha3": "ECU",
    "country-code": 218,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Egypt",
    "alpha2": "EG",
    "alpha3": "EGY",
    "country-code": 818,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "El Salvador",
    "alpha2": "SV",
    "alpha3": "SLV",
    "country-code": 222,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Equatorial Guinea",
    "alpha2": "GQ",
    "alpha3": "GNQ",
    "country-code": 226,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Eritrea",
    "alpha2": "ER",
    "alpha3": "ERI",
    "country-code": 232,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Estonia",
    "alpha2": "EE",
    "alpha3": "EST",
    "country-code": 233,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Eswatini",
    "alpha2": "SZ",
    "alpha3": "SWZ",
    "country-code": 748,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Southern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "018"
  },
  {
    "name": "Ethiopia",
    "alpha2": "ET",
    "alpha3": "ETH",
    "country-code": 231,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Falkland Islands (Malvinas)",
    "alpha2": "FK",
    "alpha3": "FLK",
    "country-code": 238,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Faroe Islands",
    "alpha2": "FO",
    "alpha3": "FRO",
    "country-code": 234,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Fiji",
    "alpha2": "FJ",
    "alpha3": "FJI",
    "country-code": 242,
    "region": "Oceania",
    "sub-region": "Melanesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "054",
    "intermediate-region-code": ""
  },
  {
    "name": "Finland",
    "alpha2": "FI",
    "alpha3": "FIN",
    "country-code": 246,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "France",
    "alpha2": "FR",
    "alpha3": "FRA",
    "country-code": 250,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "French Guiana",
    "alpha2": "GF",
    "alpha3": "GUF",
    "country-code": 254,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "French Polynesia",
    "alpha2": "PF",
    "alpha3": "PYF",
    "country-code": 258,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "French Southern Territories",
    "alpha2": "TF",
    "alpha3": "ATF",
    "country-code": 260,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Gabon",
    "alpha2": "GA",
    "alpha3": "GAB",
    "country-code": 266,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Gambia",
    "alpha2": "GM",
    "alpha3": "GMB",
    "country-code": 270,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Georgia",
    "alpha2": "GE",
    "alpha3": "GEO",
    "country-code": 268,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Germany",
    "alpha2": "DE",
    "alpha3": "DEU",
    "country-code": 276,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Ghana",
    "alpha2": "GH",
    "alpha3": "GHA",
    "country-code": 288,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Gibraltar",
    "alpha2": "GI",
    "alpha3": "GIB",
    "country-code": 292,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Greece",
    "alpha2": "GR",
    "alpha3": "GRC",
    "country-code": 300,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Greenland",
    "alpha2": "GL",
    "alpha3": "GRL",
    "country-code": 304,
    "region": "Americas",
    "sub-region": "Northern America",
    "intermediate-region": "",
    "region-code": "019",
    "sub-region-code": "021",
    "intermediate-region-code": ""
  },
  {
    "name": "Grenada",
    "alpha2": "GD",
    "alpha3": "GRD",
    "country-code": 308,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Guadeloupe",
    "alpha2": "GP",
    "alpha3": "GLP",
    "country-code": 312,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Guam",
    "alpha2": "GU",
    "alpha3": "GUM",
    "country-code": 316,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Guatemala",
    "alpha2": "GT",
    "alpha3": "GTM",
    "country-code": 320,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Guernsey",
    "alpha2": "GG",
    "alpha3": "GGY",
    "country-code": 831,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "Channel Islands",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": 830
  },
  {
    "name": "Guinea",
    "alpha2": "GN",
    "alpha3": "GIN",
    "country-code": 324,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Guinea-Bissau",
    "alpha2": "GW",
    "alpha3": "GNB",
    "country-code": 624,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Guyana",
    "alpha2": "GY",
    "alpha3": "GUY",
    "country-code": 328,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Haiti",
    "alpha2": "HT",
    "alpha3": "HTI",
    "country-code": 332,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Heard Island and McDonald Islands",
    "alpha2": "HM",
    "alpha3": "HMD",
    "country-code": 334,
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "Holy See",
    "alpha2": "VA",
    "alpha3": "VAT",
    "country-code": 336,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Honduras",
    "alpha2": "HN",
    "alpha3": "HND",
    "country-code": 340,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Hong Kong",
    "alpha2": "HK",
    "alpha3": "HKG",
    "country-code": 344,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Hungary",
    "alpha2": "HU",
    "alpha3": "HUN",
    "country-code": 348,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Iceland",
    "alpha2": "IS",
    "alpha3": "ISL",
    "country-code": 352,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "India",
    "alpha2": "IN",
    "alpha3": "IND",
    "country-code": 356,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Indonesia",
    "alpha2": "ID",
    "alpha3": "IDN",
    "country-code": 360,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Iran (Islamic Republic of)",
    "alpha2": "IR",
    "alpha3": "IRN",
    "country-code": 364,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Iraq",
    "alpha2": "IQ",
    "alpha3": "IRQ",
    "country-code": 368,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Ireland",
    "alpha2": "IE",
    "alpha3": "IRL",
    "country-code": 372,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Isle of Man",
    "alpha2": "IM",
    "alpha3": "IMN",
    "country-code": 833,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Israel",
    "alpha2": "IL",
    "alpha3": "ISR",
    "country-code": 376,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Italy",
    "alpha2": "IT",
    "alpha3": "ITA",
    "country-code": 380,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Jamaica",
    "alpha2": "JM",
    "alpha3": "JAM",
    "country-code": 388,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Japan",
    "alpha2": "JP",
    "alpha3": "JPN",
    "country-code": 392,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Jersey",
    "alpha2": "JE",
    "alpha3": "JEY",
    "country-code": 832,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "Channel Islands",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": 830
  },
  {
    "name": "Jordan",
    "alpha2": "JO",
    "alpha3": "JOR",
    "country-code": 400,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Kazakhstan",
    "alpha2": "KZ",
    "alpha3": "KAZ",
    "country-code": 398,
    "region": "Asia",
    "sub-region": "Central Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 143,
    "intermediate-region-code": ""
  },
  {
    "name": "Kenya",
    "alpha2": "KE",
    "alpha3": "KEN",
    "country-code": 404,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Kiribati",
    "alpha2": "KI",
    "alpha3": "KIR",
    "country-code": 296,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Korea (Democratic People's Republic of)",
    "alpha2": "KP",
    "alpha3": "PRK",
    "country-code": 408,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Korea, Republic of",
    "alpha2": "KR",
    "alpha3": "KOR",
    "country-code": 410,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Kuwait",
    "alpha2": "KW",
    "alpha3": "KWT",
    "country-code": 414,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Kyrgyzstan",
    "alpha2": "KG",
    "alpha3": "KGZ",
    "country-code": 417,
    "region": "Asia",
    "sub-region": "Central Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 143,
    "intermediate-region-code": ""
  },
  {
    "name": "Lao People's Democratic Republic",
    "alpha2": "LA",
    "alpha3": "LAO",
    "country-code": 418,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Latvia",
    "alpha2": "LV",
    "alpha3": "LVA",
    "country-code": 428,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Lebanon",
    "alpha2": "LB",
    "alpha3": "LBN",
    "country-code": 422,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Lesotho",
    "alpha2": "LS",
    "alpha3": "LSO",
    "country-code": 426,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Southern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "018"
  },
  {
    "name": "Liberia",
    "alpha2": "LR",
    "alpha3": "LBR",
    "country-code": 430,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Libya",
    "alpha2": "LY",
    "alpha3": "LBY",
    "country-code": 434,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "Liechtenstein",
    "alpha2": "LI",
    "alpha3": "LIE",
    "country-code": 438,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Lithuania",
    "alpha2": "LT",
    "alpha3": "LTU",
    "country-code": 440,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Luxembourg",
    "alpha2": "LU",
    "alpha3": "LUX",
    "country-code": 442,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Macao",
    "alpha2": "MO",
    "alpha3": "MAC",
    "country-code": 446,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Madagascar",
    "alpha2": "MG",
    "alpha3": "MDG",
    "country-code": 450,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Malawi",
    "alpha2": "MW",
    "alpha3": "MWI",
    "country-code": 454,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Malaysia",
    "alpha2": "MY",
    "alpha3": "MYS",
    "country-code": 458,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Maldives",
    "alpha2": "MV",
    "alpha3": "MDV",
    "country-code": 462,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Mali",
    "alpha2": "ML",
    "alpha3": "MLI",
    "country-code": 466,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Malta",
    "alpha2": "MT",
    "alpha3": "MLT",
    "country-code": 470,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Marshall Islands",
    "alpha2": "MH",
    "alpha3": "MHL",
    "country-code": 584,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Martinique",
    "alpha2": "MQ",
    "alpha3": "MTQ",
    "country-code": 474,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Mauritania",
    "alpha2": "MR",
    "alpha3": "MRT",
    "country-code": 478,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Mauritius",
    "alpha2": "MU",
    "alpha3": "MUS",
    "country-code": 480,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Mayotte",
    "alpha2": "YT",
    "alpha3": "MYT",
    "country-code": 175,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Mexico",
    "alpha2": "MX",
    "alpha3": "MEX",
    "country-code": 484,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Micronesia (Federated States of)",
    "alpha2": "FM",
    "alpha3": "FSM",
    "country-code": 583,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Moldova, Republic of",
    "alpha2": "MD",
    "alpha3": "MDA",
    "country-code": 498,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Monaco",
    "alpha2": "MC",
    "alpha3": "MCO",
    "country-code": 492,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Mongolia",
    "alpha2": "MN",
    "alpha3": "MNG",
    "country-code": 496,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Montenegro",
    "alpha2": "ME",
    "alpha3": "MNE",
    "country-code": 499,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Montserrat",
    "alpha2": "MS",
    "alpha3": "MSR",
    "country-code": 500,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Morocco",
    "alpha2": "MA",
    "alpha3": "MAR",
    "country-code": 504,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "Mozambique",
    "alpha2": "MZ",
    "alpha3": "MOZ",
    "country-code": 508,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Myanmar",
    "alpha2": "MM",
    "alpha3": "MMR",
    "country-code": 104,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Namibia",
    "alpha2": "NA",
    "alpha3": "NAM",
    "country-code": 516,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Southern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "018"
  },
  {
    "name": "Nauru",
    "alpha2": "NR",
    "alpha3": "NRU",
    "country-code": 520,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Nepal",
    "alpha2": "NP",
    "alpha3": "NPL",
    "country-code": 524,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Netherlands",
    "alpha2": "NL",
    "alpha3": "NLD",
    "country-code": 528,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "New Caledonia",
    "alpha2": "NC",
    "alpha3": "NCL",
    "country-code": 540,
    "region": "Oceania",
    "sub-region": "Melanesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "054",
    "intermediate-region-code": ""
  },
  {
    "name": "New Zealand",
    "alpha2": "NZ",
    "alpha3": "NZL",
    "country-code": 554,
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "Nicaragua",
    "alpha2": "NI",
    "alpha3": "NIC",
    "country-code": 558,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Niger",
    "alpha2": "NE",
    "alpha3": "NER",
    "country-code": 562,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Nigeria",
    "alpha2": "NG",
    "alpha3": "NGA",
    "country-code": 566,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Niue",
    "alpha2": "NU",
    "alpha3": "NIU",
    "country-code": 570,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Norfolk Island",
    "alpha2": "NF",
    "alpha3": "NFK",
    "country-code": 574,
    "region": "Oceania",
    "sub-region": "Australia and New Zealand",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "053",
    "intermediate-region-code": ""
  },
  {
    "name": "North Macedonia",
    "alpha2": "MK",
    "alpha3": "MKD",
    "country-code": 807,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Northern Mariana Islands",
    "alpha2": "MP",
    "alpha3": "MNP",
    "country-code": 580,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Norway",
    "alpha2": "NO",
    "alpha3": "NOR",
    "country-code": 578,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Oman",
    "alpha2": "OM",
    "alpha3": "OMN",
    "country-code": 512,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Pakistan",
    "alpha2": "PK",
    "alpha3": "PAK",
    "country-code": 586,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Palau",
    "alpha2": "PW",
    "alpha3": "PLW",
    "country-code": 585,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Palestine, State of",
    "alpha2": "PS",
    "alpha3": "PSE",
    "country-code": 275,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Panama",
    "alpha2": "PA",
    "alpha3": "PAN",
    "country-code": 591,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Central America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "013"
  },
  {
    "name": "Papua New Guinea",
    "alpha2": "PG",
    "alpha3": "PNG",
    "country-code": 598,
    "region": "Oceania",
    "sub-region": "Melanesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "054",
    "intermediate-region-code": ""
  },
  {
    "name": "Paraguay",
    "alpha2": "PY",
    "alpha3": "PRY",
    "country-code": 600,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Peru",
    "alpha2": "PE",
    "alpha3": "PER",
    "country-code": 604,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Philippines",
    "alpha2": "PH",
    "alpha3": "PHL",
    "country-code": 608,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Pitcairn",
    "alpha2": "PN",
    "alpha3": "PCN",
    "country-code": 612,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Poland",
    "alpha2": "PL",
    "alpha3": "POL",
    "country-code": 616,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Portugal",
    "alpha2": "PT",
    "alpha3": "PRT",
    "country-code": 620,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Puerto Rico",
    "alpha2": "PR",
    "alpha3": "PRI",
    "country-code": 630,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Qatar",
    "alpha2": "QA",
    "alpha3": "QAT",
    "country-code": 634,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Réunion",
    "alpha2": "RE",
    "alpha3": "REU",
    "country-code": 638,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Romania",
    "alpha2": "RO",
    "alpha3": "ROU",
    "country-code": 642,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Russian Federation",
    "alpha2": "RU",
    "alpha3": "RUS",
    "country-code": 643,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Rwanda",
    "alpha2": "RW",
    "alpha3": "RWA",
    "country-code": 646,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Saint Barthélemy",
    "alpha2": "BL",
    "alpha3": "BLM",
    "country-code": 652,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Saint Helena, Ascension and Tristan da Cunha",
    "alpha2": "SH",
    "alpha3": "SHN",
    "country-code": 654,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Saint Kitts and Nevis",
    "alpha2": "KN",
    "alpha3": "KNA",
    "country-code": 659,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Saint Lucia",
    "alpha2": "LC",
    "alpha3": "LCA",
    "country-code": 662,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Saint Martin (French part)",
    "alpha2": "MF",
    "alpha3": "MAF",
    "country-code": 663,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Saint Pierre and Miquelon",
    "alpha2": "PM",
    "alpha3": "SPM",
    "country-code": 666,
    "region": "Americas",
    "sub-region": "Northern America",
    "intermediate-region": "",
    "region-code": "019",
    "sub-region-code": "021",
    "intermediate-region-code": ""
  },
  {
    "name": "Saint Vincent and the Grenadines",
    "alpha2": "VC",
    "alpha3": "VCT",
    "country-code": 670,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Samoa",
    "alpha2": "WS",
    "alpha3": "WSM",
    "country-code": 882,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "San Marino",
    "alpha2": "SM",
    "alpha3": "SMR",
    "country-code": 674,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Sao Tome and Principe",
    "alpha2": "ST",
    "alpha3": "STP",
    "country-code": 678,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Middle Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "017"
  },
  {
    "name": "Saudi Arabia",
    "alpha2": "SA",
    "alpha3": "SAU",
    "country-code": 682,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Senegal",
    "alpha2": "SN",
    "alpha3": "SEN",
    "country-code": 686,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Serbia",
    "alpha2": "RS",
    "alpha3": "SRB",
    "country-code": 688,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Seychelles",
    "alpha2": "SC",
    "alpha3": "SYC",
    "country-code": 690,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Sierra Leone",
    "alpha2": "SL",
    "alpha3": "SLE",
    "country-code": 694,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Singapore",
    "alpha2": "SG",
    "alpha3": "SGP",
    "country-code": 702,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Sint Maarten (Dutch part)",
    "alpha2": "SX",
    "alpha3": "SXM",
    "country-code": 534,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Slovakia",
    "alpha2": "SK",
    "alpha3": "SVK",
    "country-code": 703,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "Slovenia",
    "alpha2": "SI",
    "alpha3": "SVN",
    "country-code": 705,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Solomon Islands",
    "alpha2": "SB",
    "alpha3": "SLB",
    "country-code": "090",
    "region": "Oceania",
    "sub-region": "Melanesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "054",
    "intermediate-region-code": ""
  },
  {
    "name": "Somalia",
    "alpha2": "SO",
    "alpha3": "SOM",
    "country-code": 706,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "South Africa",
    "alpha2": "ZA",
    "alpha3": "ZAF",
    "country-code": 710,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Southern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "018"
  },
  {
    "name": "South Georgia and the South Sandwich Islands",
    "alpha2": "GS",
    "alpha3": "SGS",
    "country-code": 239,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "South Sudan",
    "alpha2": "SS",
    "alpha3": "SSD",
    "country-code": 728,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Spain",
    "alpha2": "ES",
    "alpha3": "ESP",
    "country-code": 724,
    "region": "Europe",
    "sub-region": "Southern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": "039",
    "intermediate-region-code": ""
  },
  {
    "name": "Sri Lanka",
    "alpha2": "LK",
    "alpha3": "LKA",
    "country-code": 144,
    "region": "Asia",
    "sub-region": "Southern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "034",
    "intermediate-region-code": ""
  },
  {
    "name": "Sudan",
    "alpha2": "SD",
    "alpha3": "SDN",
    "country-code": 729,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "Suriname",
    "alpha2": "SR",
    "alpha3": "SUR",
    "country-code": 740,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Svalbard and Jan Mayen",
    "alpha2": "SJ",
    "alpha3": "SJM",
    "country-code": 744,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Sweden",
    "alpha2": "SE",
    "alpha3": "SWE",
    "country-code": 752,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "Switzerland",
    "alpha2": "CH",
    "alpha3": "CHE",
    "country-code": 756,
    "region": "Europe",
    "sub-region": "Western Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 155,
    "intermediate-region-code": ""
  },
  {
    "name": "Syrian Arab Republic",
    "alpha2": "SY",
    "alpha3": "SYR",
    "country-code": 760,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Taiwan, Province of China",
    "alpha2": "TW",
    "alpha3": "TWN",
    "country-code": 158,
    "region": "Asia",
    "sub-region": "Eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "030",
    "intermediate-region-code": ""
  },
  {
    "name": "Tajikistan",
    "alpha2": "TJ",
    "alpha3": "TJK",
    "country-code": 762,
    "region": "Asia",
    "sub-region": "Central Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 143,
    "intermediate-region-code": ""
  },
  {
    "name": "Tanzania, United Republic of",
    "alpha2": "TZ",
    "alpha3": "TZA",
    "country-code": 834,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Thailand",
    "alpha2": "TH",
    "alpha3": "THA",
    "country-code": 764,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Timor-Leste",
    "alpha2": "TL",
    "alpha3": "TLS",
    "country-code": 626,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Togo",
    "alpha2": "TG",
    "alpha3": "TGO",
    "country-code": 768,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Western Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "011"
  },
  {
    "name": "Tokelau",
    "alpha2": "TK",
    "alpha3": "TKL",
    "country-code": 772,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Tonga",
    "alpha2": "TO",
    "alpha3": "TON",
    "country-code": 776,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Trinidad and Tobago",
    "alpha2": "TT",
    "alpha3": "TTO",
    "country-code": 780,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Tunisia",
    "alpha2": "TN",
    "alpha3": "TUN",
    "country-code": 788,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "Turkey",
    "alpha2": "TR",
    "alpha3": "TUR",
    "country-code": 792,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Turkmenistan",
    "alpha2": "TM",
    "alpha3": "TKM",
    "country-code": 795,
    "region": "Asia",
    "sub-region": "Central Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 143,
    "intermediate-region-code": ""
  },
  {
    "name": "Turks and Caicos Islands",
    "alpha2": "TC",
    "alpha3": "TCA",
    "country-code": 796,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Tuvalu",
    "alpha2": "TV",
    "alpha3": "TUV",
    "country-code": 798,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Uganda",
    "alpha2": "UG",
    "alpha3": "UGA",
    "country-code": 800,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Ukraine",
    "alpha2": "UA",
    "alpha3": "UKR",
    "country-code": 804,
    "region": "Europe",
    "sub-region": "Eastern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 151,
    "intermediate-region-code": ""
  },
  {
    "name": "United Arab Emirates",
    "alpha2": "AE",
    "alpha3": "ARE",
    "country-code": 784,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "United Kingdom of Great Britain and Northern Ireland",
    "alpha2": "GB",
    "alpha3": "GBR",
    "country-code": 826,
    "region": "Europe",
    "sub-region": "Northern Europe",
    "intermediate-region": "",
    "region-code": 150,
    "sub-region-code": 154,
    "intermediate-region-code": ""
  },
  {
    "name": "United States of America",
    "alpha2": "US",
    "alpha3": "USA",
    "country-code": 840,
    "region": "Americas",
    "sub-region": "Northern America",
    "intermediate-region": "",
    "region-code": "019",
    "sub-region-code": "021",
    "intermediate-region-code": ""
  },
  {
    "name": "United States Minor Outlying Islands",
    "alpha2": "UM",
    "alpha3": "UMI",
    "country-code": 581,
    "region": "Oceania",
    "sub-region": "Micronesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "057",
    "intermediate-region-code": ""
  },
  {
    "name": "Uruguay",
    "alpha2": "UY",
    "alpha3": "URY",
    "country-code": 858,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Uzbekistan",
    "alpha2": "UZ",
    "alpha3": "UZB",
    "country-code": 860,
    "region": "Asia",
    "sub-region": "Central Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 143,
    "intermediate-region-code": ""
  },
  {
    "name": "Vanuatu",
    "alpha2": "VU",
    "alpha3": "VUT",
    "country-code": 548,
    "region": "Oceania",
    "sub-region": "Melanesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "054",
    "intermediate-region-code": ""
  },
  {
    "name": "Venezuela (Bolivarian Republic of)",
    "alpha2": "VE",
    "alpha3": "VEN",
    "country-code": 862,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "South America",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "005"
  },
  {
    "name": "Viet Nam",
    "alpha2": "VN",
    "alpha3": "VNM",
    "country-code": 704,
    "region": "Asia",
    "sub-region": "South-eastern Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": "035",
    "intermediate-region-code": ""
  },
  {
    "name": "Virgin Islands (British)",
    "alpha2": "VG",
    "alpha3": "VGB",
    "country-code": "092",
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Virgin Islands (U.S.)",
    "alpha2": "VI",
    "alpha3": "VIR",
    "country-code": 850,
    "region": "Americas",
    "sub-region": "Latin America and the Caribbean",
    "intermediate-region": "Caribbean",
    "region-code": "019",
    "sub-region-code": 419,
    "intermediate-region-code": "029"
  },
  {
    "name": "Wallis and Futuna",
    "alpha2": "WF",
    "alpha3": "WLF",
    "country-code": 876,
    "region": "Oceania",
    "sub-region": "Polynesia",
    "intermediate-region": "",
    "region-code": "009",
    "sub-region-code": "061",
    "intermediate-region-code": ""
  },
  {
    "name": "Western Sahara",
    "alpha2": "EH",
    "alpha3": "ESH",
    "country-code": 732,
    "region": "Africa",
    "sub-region": "Northern Africa",
    "intermediate-region": "",
    "region-code": "002",
    "sub-region-code": "015",
    "intermediate-region-code": ""
  },
  {
    "name": "Yemen",
    "alpha2": "YE",
    "alpha3": "YEM",
    "country-code": 887,
    "region": "Asia",
    "sub-region": "Western Asia",
    "intermediate-region": "",
    "region-code": 142,
    "sub-region-code": 145,
    "intermediate-region-code": ""
  },
  {
    "name": "Zambia",
    "alpha2": "ZM",
    "alpha3": "ZMB",
    "country-code": 894,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  },
  {
    "name": "Zimbabwe",
    "alpha2": "ZW",
    "alpha3": "ZWE",
    "country-code": 716,
    "region": "Africa",
    "sub-region": "Sub-Saharan Africa",
    "intermediate-region": "Eastern Africa",
    "region-code": "002",
    "sub-region-code": 202,
    "intermediate-region-code": "014"
  }
]
